<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="nirAccomplishment"
        :is-no-changes="isNoChanges"
        @save="saveNirAccomplishment"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="workTypeRusName(workTypeName.NirAccomplishment)" />

          <AuthorsCard
            title="Автор"
            class="mt-4"
            :selected-item.sync="nirAccomplishment.commonWork.authors"
            :is-show-mode="isShowMode"
            @updateInvalid="updateAuthorsInvalid"
          />

          <NirAccomplishmentCard
            class="mt-4"
            title="Основная информация"
            :selected-item.sync="nirAccomplishment"
            :is-show-mode="isShowMode"
            @updateInvalid="updateNirAccomplishmentInvalid"
          />

          <CommentCard
            v-if="Boolean(nirAccomplishment.commonWork.comment)"
            class="mt-4"
            :comment="nirAccomplishment.commonWork.comment"
          />

          <CreatorCard :creator-name="nirAccomplishment.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { nirAccomplishmentApi } from '@/api'
import TitleCard from '../../components/Works/elements/TitleCard'
import { NirAccomplishment } from '../../models'
import NirAccomplishmentCard from '../../components/Works/NirAccomplishment/NirAccomplishmentCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'

export default {
  name: 'NirAccomplishmentParent',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.NirAccomplishment)
    }
  },

  components: {
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    NirAccomplishmentCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    nirAccomplishment: new NirAccomplishment(),
    selectedItem: null,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    saveBtnLoading: false,
    dataLoaded: false,
    nirAccomplishmentInvalid: false,
    authorsInvalid: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.authorsInvalid || this.nirAccomplishmentInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) await this.getDictionaries([dictionaryNames.NirType, dictionaryNames.Speciality])
      await this.getWorkTypes()
      await this.getNirAccomplishment()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getNirAccomplishment() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await nirAccomplishmentApi.get(this.$route.params?.id)
          this.nirAccomplishment = new NirAccomplishment(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveNirAccomplishment(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.nirAccomplishment.id)
          this.nirAccomplishment.commonWork.workType = this.workTypeByName(workTypeName.NirAccomplishment)

        const body = this.nirAccomplishment.getForAPI()

        const data = this.nirAccomplishment.id
          ? await nirAccomplishmentApi.update(body)
          : await nirAccomplishmentApi.create(body)

        if (!this.nirAccomplishment.id) await this.$router.replace('/works/nirAccomplishment/edit/' + data.id)

        this.nirAccomplishment = new NirAccomplishment(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    async updateNirAccomplishmentInvalid(val) {
      this.nirAccomplishmentInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveNirAccomplishment
    }
  }
}
</script>

<style scoped></style>
